import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const links = [
    { label: "How it works", href: "#how" },
    { label: "vs Agents", href: "#benefits" },
    { label: "Reviews", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
  ];
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 border-b border-[var(--c4p-line)] bg-[var(--c4p-ivory)]/90 backdrop-blur"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-1">
          <span className="font-display text-[22px] leading-none text-[var(--c4p-forest)]">
            Cash<span className="text-[var(--c4p-orange)]">4</span>Properties
          </span>
        </a>

        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-sans-ui text-[14px] font-medium tracking-tight text-[var(--c4p-ink)]/85 transition hover:text-[var(--c4p-orange)]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="tel:+19102125006"
            data-testid="call-now-btn"
            className="flex items-center gap-2 font-sans-ui text-[14px] font-semibold text-[var(--c4p-ink)]"
          >
            <Phone size={14} /> (910) 212-5006
          </a>
          <a href="#lead" data-testid="get-offer-nav-btn" className="btn-primary">
            Get My Cash Offer
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="grid h-10 w-10 place-items-center rounded-lg border border-[var(--c4p-line)] md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[var(--c4p-line)] md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-sans-ui text-sm text-[var(--c4p-ink)]/85"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+19102125006"
              className="flex items-center gap-2 font-sans-ui text-sm font-semibold"
            >
              <Phone size={14} /> (910) 212-5006
            </a>
            <a href="#lead" className="btn-primary">
              Get My Cash Offer
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
